import { Drawer } from 'flowbite';
import { Dropdown } from 'flowbite';

/**
 * Handle the drawer responsible for the aside navigation
 */
function handleDrawer() {
	const drawerEl = document.getElementById('aside-navigation');
	const drawerToggle = document.getElementById('aside-navigation-toggle');
	const drawerClose = document.querySelector(
		'[aria-controls="aside-navigation"]'
	);

	const options = {
		placement: 'right',
		backdrop: true,
		bodyScrolling: false,
		edge: false,
		edgeOffset: '',
		backdropClasses: 'bg-neutral-900/80 fixed inset-0 z-40',
	};

	// instance options object
	const instanceOptions = {
		id: 'aside-navigation',
		override: true,
	};

	/*
	 * targetEl (required)
	 * options (optional)
	 * instanceOptions (optional)
	 */
	const drawer = new Drawer(drawerEl, options, instanceOptions);

	drawerToggle.addEventListener('click', () => {
		drawer.toggle();
	});
	drawerClose.addEventListener('click', () => {
		drawer.hide();
	});
}

/**
 * Handle the dropdown responsible for the language switcher
 */
function handleLanguageSwitcher() {
	const languageSwitcher = document.getElementById('languageSwitcher');
	const languageSwitcherTrigger = document.getElementById(
		'languageSwitcherTrigger'
	);

	const options = {
		placement: 'bottom',
		triggerType: 'hover',
		offsetSkidding: 0, // offset relative to the trigger element on the horizontal axis.
		offsetDistance: 10,
		delay: 300,
		ignoreClickOutsideClass: false,
	};

	// instance options object
	const instanceOptions = {
		id: 'languageSwitcher',
		override: true,
	};

	/*
	 * targetEl: required
	 * triggerEl: required
	 * options: optional
	 * instanceOptions: optional
	 */
	new Dropdown(
		languageSwitcher,
		languageSwitcherTrigger,
		options,
		instanceOptions
	);
}

function handleFrontend() {
	handleDrawer();
	handleLanguageSwitcher();
}

if (document.readyState === 'loading') {
	// Loading hasn't finished yet
	document.addEventListener('DOMContentLoaded', handleFrontend);
} else {
	// `DOMContentLoaded` has already fired
	handleFrontend();
}
